import { useEffect } from "react";
import { Store } from "lucide-react";
import { FormControl } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { setPickupLocation } from "../modules/delivery/actions";
import { pickupLocationSelector } from "../modules/delivery/selectors";
import { pickupLocationsSelector } from "../modules/store/selectors";

const Pickup = () => {
  const pickupLocations = useSelector(pickupLocationsSelector);
  const pickupLocation = useSelector(pickupLocationSelector);
  const pickupLocked = useSelector((state) => state.delivery.pickup_locked);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!pickupLocation && pickupLocations.length === 1) {
      dispatch(setPickupLocation(pickupLocations[0].id));
    }
  }, [dispatch, pickupLocation, pickupLocations]);

  if (!pickupLocations.length) {
    return (
      <div className="pickup-empty-state">
        <strong>Brak punktu odbioru</strong>
        <span>Wybierz dowóz lub spróbuj ponownie później.</span>
      </div>
    );
  }

  return (
    <div className="pickup-section">
      <div className="pickup-heading">
        <div>
          <span className="interface-label">Odbiór osobisty</span>
          <strong>
            {pickupLocation ? "Punkt odbioru wybrany" : "Gdzie odbierasz?"}
          </strong>
        </div>
      </div>

      <div className="pickup-location-card">
        <div className="pickup-store-marker">
          <Store strokeWidth={1.8} aria-hidden="true" />
        </div>
        <div className="pickup-location-content">
          <span className="pickup-location-label">Lokalizacja</span>
          {pickupLocations.length > 1 && !pickupLocked ? (
            <FormControl
              as="select"
              className="pickup-location-select"
              onChange={(event) =>
                dispatch(setPickupLocation(event.target.value))
              }
              value={(pickupLocation && pickupLocation.id) || ""}
              size="sm"
              aria-label="Wybierz punkt odbioru"
            >
              <option value="">Wybierz lokalizację</option>
              {pickupLocations.map((location) => (
                <option key={location.id} value={location.id}>
                  {location.name}
                </option>
              ))}
            </FormControl>
          ) : (
            <strong className="pickup-location-name">
              {pickupLocation?.name || pickupLocations[0].name}
            </strong>
          )}
          {pickupLocked && (
            <span className="pickup-location-fixed">
              To miejsce jest przypisane do linku zamówienia
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default Pickup;
